// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pjgK","colBig":"styles_colBig__1_4xo","colSmall":"styles_colSmall__1uAKj"};